/* eslint-disable react/jsx-props-no-spreading */
import type { FunctionComponent } from 'react';
import { Redirect, RouteComponentProps } from '@reach/router';
import useAuth from '@utils/hooks/useAuth';

interface GuardRouteProps extends RouteComponentProps {
    component: FunctionComponent<RouteComponentProps>;
    condition?: (isAuthed: boolean) => boolean;
    redirect?: string;
}

const { PUBLIC_URL } = process.env;

const GuardRoute = ({
    component: Component,
    redirect = '/login',
    condition = (isAuthed) => isAuthed,
    ...props
}: GuardRouteProps): JSX.Element => {
    const { auth } = useAuth();

    return condition(auth.loggedIn) ? (
        <Component {...props} />
    ) : (
        <Redirect to={`${PUBLIC_URL}${redirect}`} noThrow />
    );
};

export default GuardRoute;
